$(function () {
  initCollectionMobileSort();
  initCollectionMobileFilter();
  initScrollToTop();
});

function initCollectionMobileSort() {
  const sort = $(".collection-filters-mobile .collection-sorter select");

  if (sort.length < 1) return;

  const sortWidthRef = $(".collection-filters-mobile .fn-sort-width");
  const text = sort.find("option:selected").text();

  sortWidthRef.text(text);

  const width = sortWidthRef.innerWidth();
  sort.width(width + 25);
}

function initCollectionMobileFilter() {
  const filterButton = $(".collection-filters-mobile .fn-mobile-filter");
  const mobileFilters = $(
    ".collection-controls-top .collection__filters-wrapper"
  );

  if (filterButton.length < 1) return;

  filterButton.on("click", function () {
    mobileFilters.slideToggle();
  });
}

function initScrollToTop() {
  $(".fn-scroll-to-top").on("click", function () {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  });
}
